import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { Country } from '../utils/ContextProviders/appContextTypes';
import { ResponseError } from '../utils/Data/dataTypes';
import { isCallSuccessful } from '../utils/Data/dataUtilities';
import { getCountriesByPlanCode } from '../utils/Data/localizationConnector';

export function useGetCountries() {
  const [countries, setCountries] = useState<Country[]>([]);
  useEffect(() => {
    Promise.resolve(getCountriesByPlanCode()).then(
      (response: AxiosResponse<any> | ResponseError) => {
        // if call is not successful, the default of [] is used and handled where this is used
        if (isCallSuccessful(response.status)) {
          setCountries(response.data);
        }
      },
    );
  }, []);
  return countries;
}

export default useGetCountries;
